import { useEffect } from 'react';
import { Navigate } from 'react-router';

import { useQueryClient } from '@tanstack/react-query';

import { useAppDispatch } from '@/hooks/redux';
import { logout } from '@/store/userSlice';

const Logout = () => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();

  useEffect(() => {
    dispatch(logout()).then(
      queryClient.invalidateQueries({ refetchType: 'inactive' })
    );
  }, [dispatch, queryClient]);

  return <Navigate to="/auth/login" />;
};

export default Logout;
